<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('dialog_title_expo_info') || '展会信息'"
      direction="rtl"
      :size="900"
      @close="$refs.main.cancel()"
    >
      <edit-form
        ref="main"
        :disabled="disabled"
        :expoInfoCode="expoInfoCode"
        @close="close()"
      />
    </el-drawer>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  props: {
    visible: { type: Boolean, default: false },
    expoInfoCode: { type: String, default: '' },
    pageType: { type: String, default: '' },
  },
  components: {
    EditForm,
  },
  data() {
    return {
      skuDisabled: false,
    }
  },
  computed: {
    disabled() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      if (!this.disabled) this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
